import { render, staticRenderFns } from "./EmployeeGroupSchedulePurgeButton.vue?vue&type=template&id=04595e5e&scoped=true&"
import script from "./EmployeeGroupSchedulePurgeButton.vue?vue&type=script&lang=js&"
export * from "./EmployeeGroupSchedulePurgeButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04595e5e",
  null
  
)

export default component.exports